'use strict';
(function () {

    var EventDisptacher = require('./eventdispatcher'),
        _ = require('lodash');

    var EnterFrame = function () {
        _.bindAll(this);
        EventDisptacher.call(this);
    };

    var _tick = function () {
//        console.log(this.dispatchEvent);
        this.requestId = requestAnimationFrame(_.bind(_tick, this));
        this.dispatchEvent(new Event(EnterFrame.RENDER));
    };

    EnterFrame.RENDER = 'render';
    EnterFrame.prototype = _.extend({
        start: function () {
            if (!this.requestId) {
                _.bind(_tick, this)();
            }
        },
        stop: function () {
            if (this.requestId) {
                cancelAnimationFrame(this.requestId);
                this.requestId = undefined;
            }
        },
    }, EventDisptacher.prototype);
    
    module.exports = EnterFrame;
}());


/** WEBPACK FOOTER **
 ** ./holiday-map/util/enterframe.js
 **/